/**
 * Legacy Capacitor shell helpers. Native production apps are Kotlin-only;
 * Capacitor packages were removed from root package.json. These always
 * report non-native so cookie/session web auth stays on the browser path.
 */

const ACCESS_KEY = 'ninpo_native_access_token';
const REFRESH_KEY = 'ninpo_native_refresh_token';

const canUseStorage = (): boolean => typeof localStorage !== 'undefined';

/** Always false — Capacitor client path retired. */
export const isNativeCapacitorClient = (): boolean => false;

export const readNativeAccessToken = (): string | undefined => {
  if (!canUseStorage()) return undefined;
  const token = localStorage.getItem(ACCESS_KEY)?.trim();
  return token || undefined;
};

export const readNativeRefreshToken = (): string | undefined => {
  if (!canUseStorage()) return undefined;
  const token = localStorage.getItem(REFRESH_KEY)?.trim();
  return token || undefined;
};

export const persistNativeAuthTokens = (accessToken?: string, refreshToken?: string): void => {
  if (!canUseStorage()) return;
  if (accessToken?.trim()) {
    localStorage.setItem(ACCESS_KEY, accessToken.trim());
  }
  if (refreshToken?.trim()) {
    localStorage.setItem(REFRESH_KEY, refreshToken.trim());
  }
};

export const clearNativeAuthTokens = (): void => {
  if (!canUseStorage()) return;
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
};
